import { IPublicClientApplication } from '@azure/msal-browser';
import { EligibilityRuleType } from '../../models';
import { ApiEndpointCallStatesStore } from '../api-endpoint-call-states-store';
import { FetchContext } from '../fetch-context';
import { promiseWithObservableState } from '../promise-with-observable-state';
import { withApiAccessToken } from '../with-api-access-token';
import { getEligibilityRules } from './index';

export const createEligibilityRulesApiEndpoints = (
  fetchContext: FetchContext,
  apiEndpointCallStates: ApiEndpointCallStatesStore,
) => ({
  getEligibilityRules: (instance: IPublicClientApplication, code: EligibilityRuleType) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => getEligibilityRules(fetchContext, code, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('getEligibilityRules', isInFlight);
    },
  ),
});
